import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GlobalCfgService } from './globalcfg.service';
import { environment } from '../environments/environment';

@Injectable()

export class AuthService {

    constructor(private http:HttpClient, 
                private globalCfgService : GlobalCfgService) { }

    login(userObj){
        return this.http.post(environment.apiurl + '/RMUsers/login', userObj);
    }

    resetPwdWithEmail(email) {
        return this.http.post(environment.apiurl + '/RMUsers/reset', {email: email});
    }

    resetPassword(newPassword, tmpToken) {
        return this.http.post(environment.apiurl + '/RMUsers/reset-password?access_token=' + tmpToken, {newPassword: newPassword});
    }

    changePassword(obj) {
        return this.http.post(environment.apiurl + '/RMUsers/change-password?access_token=' + this.globalCfgService.getAccessToken(), obj);
    }

    logout() {
        return this.http.post(environment.apiurl + '/RMUsers/logout?access_token=' + this.globalCfgService.getAccessToken(), {});
    }

    getRoles() {
        var filter = JSON.stringify({
            order: 'description ASC'
        });
        return this.http.get(environment.apiurl + '/RMRoles?access_token=' + this.globalCfgService.getAccessToken() + '&filter=' + filter);
    }

    addRole(rec) {
        return this.http.post(environment.apiurl + '/RMRoles?access_token=' + this.globalCfgService.getAccessToken(), rec);
    }

    updateRole(id, name, description) {
        return this.http.patch(environment.apiurl + '/RMRoles/' + id + '?access_token=' + this.globalCfgService.getAccessToken(), {
            name: name,
            description: description
        });
    }

    deleteRole(id) {
        return this.http.delete(environment.apiurl + '/RMRoles/' + id + '?access_token=' + this.globalCfgService.getAccessToken());
    }

}